export interface Journey {
  id: string;
  type: string;
  title: string;
  description: string;
  icon: string;
  color: string;
  progress: number;
  isActive: boolean;
}

export const mockJourneys: Journey[] = [
  {
    id: 'new-mom',
    type: 'new-mom',
    title: 'New Mom',
    description: 'Your pregnancy and newborn care companion',
    icon: 'child-care',
    color: '#FFC0CB',
    progress: 45,
    isActive: true,
  },
  {
    id: 'fresh-grad',
    type: 'fresh-grad',
    title: 'Fresh Graduate',
    description: 'Starting your career journey',
    icon: 'school',
    color: '#87CEEB',
    progress: 0,
    isActive: false,
  },
  {
    id: 'young-family',
    type: 'young-family',
    title: 'Young Family',
    description: "Building your family's future",
    icon: 'family-restroom',
    color: '#98D8C8',
    progress: 0,
    isActive: false,
  },
  {
    id: 'career-move',
    type: 'career-move',
    title: 'Career Advancement',
    description: 'Taking your career to the next level',
    icon: 'trending-up',
    color: '#FFD700',
    progress: 0,
    isActive: false,
  },
  {
    id: 'health-boost',
    type: 'health-boost',
    title: 'Health & Wellness',
    description: 'Your path to better health',
    icon: 'favorite',
    color: '#FF6B6B',
    progress: 0,
    isActive: false,
  },
  {
    id: 'pre-retiree',
    type: 'pre-retiree',
    title: 'Pre-Retirement',
    description: 'Planning for your golden years',
    icon: 'beach-access',
    color: '#DDA15E',
    progress: 0,
    isActive: false,
  },
];

export interface ChecklistItem {
  id: string;
  title: string;
  description: string;
  dueDate?: string;
  completed: boolean;
  category: string;
}

export const mockNewMomChecklist: ChecklistItem[] = [
  {
    id: 'c1',
    title: 'First Trimester Visit',
    description: 'Schedule your initial prenatal checkup',
    dueDate: '2025-11-15',
    completed: true,
    category: 'Medical',
  },
  {
    id: 'c2',
    title: 'Prenatal Vitamins',
    description: 'Start taking folic acid and prenatal vitamins',
    completed: true,
    category: 'Health',
  },
  {
    id: 'c3',
    title: 'Ultrasound Scan',
    description: 'Book your 12-week ultrasound appointment',
    dueDate: '2025-11-20',
    completed: false,
    category: 'Medical',
  },
  {
    id: 'c4',
    title: 'Maternity Insurance Review',
    description: 'Review your maternity coverage with AIA',
    dueDate: '2025-11-25',
    completed: false,
    category: 'Financial',
  },
  {
    id: 'c5',
    title: 'Hospital Pre-registration',
    description: 'Register at your chosen delivery hospital',
    dueDate: '2025-12-15',
    completed: false,
    category: 'Planning',
  },
  {
    id: 'c6',
    title: 'Nursery Planning',
    description: "Start planning your baby's nursery",
    completed: false,
    category: 'Preparation',
  },
];

export const mockPreRetireeChecklist: ChecklistItem[] = [
  {
    id: 'pr1',
    title: 'Review Retirement Savings',
    description: 'Evaluate your MPF and savings accounts',
    completed: false,
    category: 'Financial',
  },
  {
    id: 'pr2',
    title: 'Health Insurance Review',
    description: 'Ensure adequate coverage for retirement',
    completed: false,
    category: 'Insurance',
  },
  {
    id: 'pr3',
    title: 'Estate Planning',
    description: 'Update your will and beneficiaries',
    completed: false,
    category: 'Legal',
  },
  {
    id: 'pr4',
    title: 'Retirement Budget',
    description: 'Create a post-retirement budget plan',
    completed: false,
    category: 'Financial',
  },
];
